<template>
  <div class="container customer-edi-container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="2">
        <v-toolbar-title class="font-bold">{{$t("lbl.repositoryMatching.page_header")}}</v-toolbar-title>
      </v-col>
      <v-col cols="5" class="text-right pr-0">
        EDI File Upload
        <span style="color: #57585A; font-size:14px;">
          <span class="pl-0 pr-0"><v-avatar size="14" :color="uploadingStatusNm == 'Completed' ? successColor : errorColor"></v-avatar></span> {{ uploadingStatusNm }}
          <span v-show="uploadingStatusStartDt !== ''"><span class="pl-2 font-extrabold dashboard-status-start">Start</span> : {{ uploadingStatusStartDt }}</span>
          <span v-show="uploadingStatusEndDt !== ''"><span class="pl-2 font-extrabold dashboard-status-end">End</span> : {{ uploadingStatusEndDt }}</span>
        </span>
      </v-col>
      <v-col cols="5" class="text-right pr-0">
        Repository Matching
        <span style="color: #57585A; font-size:14px;">
          <span class="pl-0 pr-0"><v-avatar size="15" :color="matchingStatusNm == 'Completed' ? successColor : errorColor"></v-avatar></span> {{ matchingStatusNm }}
          <span v-show="matchingStatusStartDt !== ''"><span class="pl-2 font-extrabold dashboard-status-start">Start</span> : {{ matchingStatusStartDt }}</span>
          <span v-show="matchingStatusEndDt !== ''"><span class="pl-2 font-extrabold dashboard-status-end">End</span> : {{ matchingStatusEndDt }}</span>
        </span>
      </v-col>
    </v-row>
    <!-- Condition Search & Button -->
    <v-row class="custom-form-control custom-form-control-type-3 custom-figma-1">
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{$t('btn.common.collapseConditions')}}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{$t('btn.common.expandConditions')}}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <!-- Condition Search -->
          <v-col class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-figma-1" cols="12" lg="5" md="5">
            <v-row>
              <!-- Condition message type -->
              <v-col cols="12" md="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="mainSearchItems.data[0].MSG_SNDR"
                  :label="$t('lbl.common.conditionSearch.findbySender')"
                  @keyup.enter="searchItem"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="mainSearchItems.data[0].MSG_RCVR"
                  :label="$t('lbl.common.conditionSearch.findbyReceiver')"
                  @keyup.enter="searchItem"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="mainSearchItems.data[0].MSG_ID"
                  :label="$t('lbl.common.conditionSearch.findbyMessage')"
                  @keyup.enter="searchItem"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="pt-0 pb-0 pr-24px">
                <v-autocomplete
                  v-model="mainSearchItems.data[0].PRCS_STS"
                  :items="status_arr"
                  :menu-props="{offsetY: true,}"
                  @change="searchItem"
                  :label="$t('lbl.common.conditionSearch.selectStatus')"
                  hide-details
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 mt-0 text-right pr-0 custom-figma-1"
            cols="12"
            lg="7"
            md="7"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-autocomplete
                v-model="mainSearchItems.data[0].DAT_TYPE"
                :label="$t('lbl.common.conditionSearch.dateType')"
                :items="dateTypes"
                :menu-props="{offsetY: true,}"
                @change="changeDtTp"
                hide-details
                dense
                solo
              ></v-autocomplete>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromdate_menu"
                v-model="fromdate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="mainSearchItems.init.FR_DAT"
                    :placeholder="' '"
                    :disabled="mainSearchItems.data[0].DAT_TYPE == undefined || mainSearchItems.data[0].DAT_TYPE == null || mainSearchItems.data[0].DAT_TYPE == ''"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    hide-details
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="mainSearchItems.init.FR_DAT"
                  @input="fromdate_menu = false; changeDate('from')"
                  :max="getMaxDate"
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="fromdate_menu = false"
                    text
                    color="primary"
                  >{{$t('btn.common.cancel')}}</v-btn>
                  <v-btn
                    @click="$refs.fromdate_menu.save(mainSearchItems.init.FR_DAT)"
                    text
                    color="primary"
                  >{{$t('btn.common.ok')}}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="todate_menu"
                v-model="todate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="mainSearchItems.init.TO_DAT"
                    :placeholder="' '"
                    :disabled="mainSearchItems.data[0].DAT_TYPE == undefined || mainSearchItems.data[0].DAT_TYPE == null || mainSearchItems.data[0].DAT_TYPE == ''"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    hide-detail
                    @keypress="formatDate('to', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="mainSearchItems.init.TO_DAT"
                  :allowed-dates="allowedDates"
                  @input="todate_menu = false; changeDate('to')"
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="todate_menu = false"
                    text
                    color="primary"
                  >{{$t('btn.common.cancel')}}</v-btn>
                  <v-btn
                    @click="$refs.todate_menu.save(mainSearchItems.init.TO_DAT)"
                    text
                    color="primary"
                  >{{$t('btn.common.ok')}}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-btn
                @click.native="searchItem()"
                class="search-data-analysis-button btn btn-top btn-search btn-width-1 mt-0 mb-0"
                color="primary"
              >
                <v-icon x-small class="mr-2">fa fa-search</v-icon>
                <span class="btn-text">{{$t('btn.common.search')}}</span>
              </v-btn>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-btn
                @click="openEdiFileUploadDialog()"
                class="file-upload-button btn btn-top btn-search btn-width-2 mt-0 mb-0"
                color="primary"
              >
                <span class="btn-text">{{$t('lbl.repositoryMatching.EDIFileUpload')}}</span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Button control-->
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <div class="btn-form-control mb-0">
                  <v-tooltip top :disabled="isEnableMergeView" :max-width="tooltipWidth">
                    <template v-slot:activator="{ on}">
                      <div v-on="on" class="btn-tooltip">
                        <v-btn
                          @click="openMergeView"
                          :disabled="!isEnableMergeView"
                          class="btn btn-add btn-width-4"
                          color="#353f61"
                        >
                          <v-icon x-small class="mr-2">far fa-object-ungroup</v-icon>
                          <span class="btn-text">{{$t('btn.repositoryMatching.mergeLayout')}}</span>
                        </v-btn>
                      </div>
                    </template>
                    <span>{{$t("msg.repositoryMatching.mergerCompareRepoMatchingTooltipMsg")}}</span>
                  </v-tooltip>
                  <v-tooltip top :disabled="!isEnableExtMatching" :max-width="tooltipWidth">
                    <template v-slot:activator="{ on}">
                      <div v-on="on" class="btn-tooltip">
                        <v-btn
                          @click="openRepositoryMatchingDialog()"
                          :disabled="isEnableExtMatching"
                          class="btn btn-add btn-width-4"
                          color="#353f61"
                        >
                          <v-icon x-small class="mr-2">fa fa-magic</v-icon>
                          <span class="btn-text">{{$t('btn.repositoryMatching.exeMatching')}}</span>
                        </v-btn>
                      </div>
                    </template>
                    <span>{{$t("msg.repositoryMatching.executeMatchingTooltipMsg")}}</span>
                  </v-tooltip>
                  <v-tooltip top :disabled="!isEnableMoveToSrm" :max-width="tooltipWidth">
                    <template v-slot:activator="{ on}">
                      <div v-on="on" class="btn-tooltip">
                        <v-btn
                          @click="addSRMList"
                          :disabled="isEnableMoveToSrm"
                          class="btn btn-add btn-width-4"
                          color="#0082ba"
                        >
                          <v-icon x-small class="mr-2">far fa-save</v-icon>
                          <span class="btn-text">{{$t('btn.repositoryMatching.moveSRMList')}}</span>
                        </v-btn>
                      </div>
                    </template>
                    <span>{{$t("msg.repositoryMatching.moveSRMListTooltipMsg")}}</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="3" md="3">
            <v-row>
              <v-col class="pb-0 pt-0" cols="12" md="12">
                <div class="btn-form-control mb-0">
                  <v-tooltip top :disabled="!isEnableRollbackStt" :max-width="tooltipWidth">
                    <template v-slot:activator="{ on}">
                      <div v-on="on" class="btn-tooltip">
                        <v-btn
                          @click="statusRollBack()"
                          :disabled="isEnableRollbackStt"
                          class="btn btn-delete btn-width-4"
                          color="#cd5f5f"
                        >
                          <v-icon x-small class="mr-2">fas fa-undo-alt</v-icon>
                          <span class="btn-text">{{$t('btn.repositoryMatching.statusRollback')}}</span>
                        </v-btn>
                      </div>
                    </template>
                    <span>{{$t("msg.repositoryMatching.statusRollBackTooltipMsg")}}</span>
                  </v-tooltip>
                  <v-tooltip top :disabled="!isEnableDelete" :max-width="tooltipWidth">
                    <template v-slot:activator="{ on}">
                      <div v-on="on" class="btn-tooltip">
                        <v-btn
                          @click="deleteData()"
                          :disabled="isEnableDelete"
                          class="btn btn-delete btn-width-1"
                          color="#cd5f5f"
                        >
                          <span class="btn-text">{{$t('btn.common.delete')}}</span>
                        </v-btn>
                      </div>
                    </template>
                    <span>{{$t("msg.repositoryMatching.deleteTooltipMsg")}}</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="3" md="3" class="filter-search">
            <v-row class="justify-end">
              <v-col class="mr-0 pr-0 pl-0" lg="5" md="5">
                <v-select
                  v-model="searchBy"
                  :items="searchByItems"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  @change="onFilterFromMainGrid"
                  class="search-by data-table-select-box custom-selectbox pla-col mr-0 flat-file-selectbox"
                  height="30"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col class="pb-0 pt-0 pl-0 text-search-filter" cols="12" md="6">
                <v-text-field
                  v-model="search"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  @input="onFilterFromMainGrid"
                  @click:append="onFilterFromMainGrid"
                  @keyup.enter="onFilterFromMainGrid"
                  class="data-table-filter-text-field search-button-data-analysis-table"
                  heigth="30"
                  append-icon="fa fa-search"
                  outlined
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      
      
    </v-row>
    <!-- Table content -->
    <v-row>
      <!-- // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu -->
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <!-- <v-data-table
          ref="customer_list_table"
          :headers="repository_matching_table_headers"
          :items="repository_matching_table_data"
          :hide-default-footer="true"
          :items-per-page="itemsPerPage"
          :sort-by="'MST_UPD_DT'"
          :sort-desc="true"
          :custom-sort="customSort"
          :fixed-header="true"
          :height="tableHeight"
          @page-count="pageCount = $event"
          class="list-table matching-repository-table table-h2"
        >
          <template v-slot:header.checkbox="{ header }">
            <v-checkbox
              @change="selectAllChange"
              :disabled="disableCheckAll"
              class="select-checkbox-layout-table align-center justify-center"
              color="#dbd7db"
              dense
              hide-details
            ></v-checkbox>
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <template v-for="item1 in items">
                <template v-for="(item, k) in item1.data">
                  <template v-if="item1.LAY_PRCS_NO === null">
                    <tr :key="item.ROWID">
                      <td class="checkbox-col">
                        <v-checkbox
                          class="select-checkbox-layout-table align-center justify-center"
                          color="#dbd7db"
                          :disabled="item.MST_PRCS_STS=='MAON'"
                          dense
                          hide-details
                          v-model="item.checked"
                          @click.native="selectItemChange($event, item)"
                          @click.native.stop
                        ></v-checkbox>
                      </td>
                      <td class="sender-col no-wrap">{{ item.MST_MSG_SNDR }}</td>
                      <td class="receiver-col no-wrap">{{ item.MST_MSG_RCVR }}</td>
                      <td class="message-col no-wrap">{{ item.MST_MSG_ID }}</td>
                      <td class="version-col no-wrap">{{ item.MST_MSG_VER }}</td>
                      <td
                        v-if="item.MST_PRCS_STS == 'UPLD'"
                        class="uploaded_status_cell no-wrap"
                      >{{$t('btn.repositoryMatching.uploaded')}}</td>
                      <td
                        v-if="item.MST_PRCS_STS == 'LAYO'"
                        class="layout_created_status_cell no-wrap"
                      >{{$t('btn.repositoryMatching.layoutCreated')}}</td>
                      <td
                        v-if="item.MST_PRCS_STS == 'MAON'"
                        class="matching_processing_cell no-wrap"
                      >{{$t('btn.repositoryMatching.matchingProcessing')}}</td>
                      <td
                        v-if="item.MST_PRCS_STS == 'MAEN'"
                        class="matching_completed_cell no-wrap"
                      >{{$t('btn.repositoryMatching.matchingCompleted')}}</td>
                      <td class="layout-col text-center">
                        <a
                          @click="openLayoutView(item)"
                        >{{$t('btn.common.view')}}</a>
                      </td>
                      <td class="map-col no-wrap">
                        <div v-if="item.MST_PRCS_STS == 'MAEN'">
                          <span v-if="item.MAP_NAME == 'No Matched'">{{ item.MAP_NAME }}</span>
                          <a
                            @click="openMatchedMapListDialog(item)"
                            v-if="item.MAP_NAME != 'No Matched'"
                            class="layout-map-color"
                          >{{ item.MAP_NAME }} ({{ item.MAX_RATIO }})</a>
                        </div>
                      </td>
                      <td class="flatfile-layout-col no-wrap">{{ item.FFL_FILE_NAME }}</td>
                      <td class="mapping-definition-col no-wrap">{{ item.MPD_FILE_NAME }}</td>
                      <td class="date-col no-wrap">{{ item.LAY_UPLD_DT }}</td>
                      <td class="date-col no-wrap">{{ item.MST_UPD_DT }}</td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr :key="item.ROWID">
                      <td class="checkbox-col" :rowspan="getRowspan(item1)" v-if="k === 0">
                        <v-checkbox
                          v-model="item1.checked"
                          @click.native="selectItemChangeMerged($event, item1)"
                          @click.native.stop
                          :disabled="item.MST_PRCS_STS=='MAON'"
                          class="select-checkbox-layout-table align-center justify-center"
                          color="#dbd7db"
                          dense
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td class="sender-col no-wrap">{{ item.MST_MSG_SNDR }}</td>
                      <td class="receiver-col no-wrap">{{ item.MST_MSG_RCVR }}</td>
                      <td class="message-col no-wrap">{{ item.MST_MSG_ID }}</td>
                      <td class="version-col no-wrap">{{ item.MST_MSG_VER }}</td>
                      <td
                        v-if="item.MST_PRCS_STS == 'UPLD'"
                        class="uploaded_status_cell no-wrap"
                      >{{$t('btn.repositoryMatching.uploaded')}}</td>
                      <td
                        v-if="item.MST_PRCS_STS == 'LAYO'"
                        class="layout_created_status_cell no-wrap"
                      >{{$t('btn.repositoryMatching.layoutCreated')}}</td>
                      <td
                        v-if="item.MST_PRCS_STS == 'MAON'"
                        class="matching_processing_cell no-wrap"
                      >{{$t('btn.repositoryMatching.matchingProcessing')}}</td>
                      <td
                        v-if="item.MST_PRCS_STS == 'MAEN'"
                        class="matching_completed_cell no-wrap"
                      >{{$t('btn.repositoryMatching.matchingCompleted')}}</td>
                      <td
                        class="layout-col text-center"
                        :rowspan="getRowspan(item1)"
                        v-if="k === 0"
                      >
                        <a
                          @click="openLayoutView(item)"
                          class="layout-map-color"
                        >{{$t('btn.common.view')}}</a>
                      </td>
                      <td class="map-col no-wrap" :rowspan="getRowspan(item1)" v-if="k === 0">
                        <div v-if="item.MST_PRCS_STS == 'MAEN'">
                          <span v-if="item.MAP_NAME == 'No Matched'">{{ item.MAP_NAME }}</span>
                          <a
                            @click="openMatchedMapListDialog(item)"
                            v-if="item.MAP_NAME != 'No Matched'"
                            class="layout-map-color"
                          >{{ item.MAP_NAME }} ({{ item.MAX_RATIO }})</a>
                        </div>
                      </td>
                      <td
                        class="flatfile-layout-col no-wrap"
                        :rowspan="getRowspan(item1)"
                        v-if="k === 0"
                      >{{ item.FFL_FILE_NAME }}</td>
                      <td
                        class="mapping-definition-col no-wrap"
                        :rowspan="getRowspan(item1)"
                        v-if="k === 0"
                      >{{ item.MPD_FILE_NAME }}</td>
                      <td class="date-col no-wrap">{{ item.LAY_UPLD_DT }}</td>
                      <td class="date-col no-wrap">{{ item.MST_UPD_DT }}</td>
                    </tr>
                  </template>
                </template>
              </template>
            </tbody>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table> -->
        <v-table
          ref="customer_list_table"
          :height="tableHeight"
          :title-rows="titleRows"
          :columns="columns"
          :table-data="repository_matching_table_data"
          :row-class-name="setRowClassName"
          :title-row-height="$vuetify.theme.dark ? 45: 41"
          :row-height="35"
          :class="$vuetify.theme.dark
              ? 'v-search-list-table-merge srm-list-table repo-list-table custom-figma-1'
              : 'v-search-list-table-merge srm-list-table repo-list-table border-top'"
          :errorContent="'No matching records found'"
          :border-header-height="$vuetify.theme.dark ? 0: 4"
          is-horizontal-resize
          is-vertical-resize
          width="100%"
          :paging-index="(page-1)*itemsPerPage"
          :multiple-sort="false"
          :select-all="selectAllChange"
          :select-change="itemTableChange"
          :cell-merge="cellMerge"
          :after-update-callback="afterUpdateTable"
          :row-click="rowClick"
          :row-mouse-enter="rowEnter"
          :row-mouse-leave="rowLeave"
          @sort-change="sortChange"
        >
          <template v-slot:merge_custome=" { item } ">
            <v-icon v-if="item.MST_PRCS_STS ==='MAON'" x-small>far fa-window-close</v-icon>
          </template>
          <template v-slot:MST_MSG_SNDR="{ item }" class="type-col">
            <font class="sender-col">{{item.MST_MSG_SNDR}}</font>
          </template>item
          <template v-slot:MST_MSG_RCVR="{ item }">
            <font class="receiver-col" >{{item.MST_MSG_RCVR}}</font>
          </template>
          <template v-slot:MST_MSG_ID="{ item }">
            <font class="message-col">{{item.MST_MSG_ID}}</font>
          </template>
          <template v-slot:MST_MSG_VER="{ item }">
            <font class="version-col">{{item.MST_MSG_VER}}</font>
          </template>
          <template v-slot:MST_PRCS_STS="{ item }">
            <font
              v-if="item.MST_PRCS_STS == 'UPLD'"
              class="uploaded_status_cell no-wrap"
            >{{$t('btn.repositoryMatching.uploaded')}}</font>
            <font
              v-if="item.MST_PRCS_STS == 'LAYO'"
              class="layout_created_status_cell no-wrap"
            >{{$t('btn.repositoryMatching.layoutCreated')}}</font>
            <font
              v-if="item.MST_PRCS_STS == 'MAON'"
              class="matching_processing_cell no-wrap"
            >{{$t('btn.repositoryMatching.matchingProcessing')}}</font>
            <font
              v-if="item.MST_PRCS_STS == 'MAEN'"
              class="matching_completed_cell no-wrap"
            >{{$t('btn.repositoryMatching.matchingCompleted')}}</font>
          </template>
          <template v-slot:merge_layout=" { item } ">
            <a class="link-file-text" @click="openLayoutView(item)">{{$t('btn.common.view')}}</a>
          </template>
          <template v-slot:merge_FFL_FILE_NAME=" { item } ">
            <font>{{item.FFL_FILE_NAME}}</font>
          </template>
          <template v-slot:merge_MPD_FILE_NAME=" { item } ">
            <font>{{item.MPD_FILE_NAME}}</font>
          </template>
          <template v-slot:merge_MAP_NAME=" { item } ">
            <div v-if="item.MST_PRCS_STS == 'MAEN'">
              <font v-if="item.MAP_NAME == 'No Matched'">{{ item.MAP_NAME }}</font>
              <a
                @click="openMatchedMapListDialog(item)"
                v-if="item.MAP_NAME != 'No Matched'"
                class="layout-map-color"
              >{{ item.MAP_NAME }} ({{ item.MAX_RATIO }})</a>
            </div>
          </template>
          <template v-slot:LAY_UPLD_DT="{ item }" class="date-col no-wrap">
            <font>{{item.LAY_UPLD_DT}}</font>
          </template>
          <template v-slot:MST_UPD_DT="{ item }" class="date-col no-wrap">
            <font>{{item.MST_UPD_DT}}</font>
          </template>
        </v-table>
      </v-col>
    </v-row>

    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <matched-map-list-dialog
        v-if="dialog.type == 'MatchedMapList'"
        :id="dialog.id"
        :ref='"dialog-" + dialog.id'
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :reloadList="searchItem"
        :srm_item="dialog.item"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        class="analyzed-layout-dialog matched-map-list"
      ></matched-map-list-dialog>

      <repository-matching-dialog
        v-if="dialog.type == 'repositoryMatching'"
        :id="dialog.id"
        :ref='"dialog-" + dialog.id'
        :closeDialog="removeDialog"
        :eventCb="searchItem"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @select-close="searchItem"
        class="custom-dialog dialog-small"
      ></repository-matching-dialog>

      <edi-upload-dialog
        v-if="dialog.type == 'ediUploadFile'"
        class="custom-dialog dialog-small"
        :id="dialog.id"
        :ref='"dialog-" + dialog.id'
        :callby="'MATCHING'"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :queryList="searchItem"
        :options="dialog.options"
      ></edi-upload-dialog>

      <merge-compare-dialog
        v-if="dialog.type == 'MergeCompare'"
        :params="params"
        :id="dialog.id"
        :ref='"dialog-" + dialog.id'
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        class="custom-dialog compare-merge-dialog"
      ></merge-compare-dialog>
    </div>
    <dialogWindow
      ref="deleteDialog"
      size="max"
      title="Delete Data"
      :detail="$t('msg.common.infoConfirm.detail',['delete the selected items'])"
      color="confirmation"
      show-cancel="true"
      @select-ok="onDelete"
    ></dialogWindow>
    <dialogWindow
      ref="deleteSuccesssDialog"
      size="max"
      title="Delete Success"
      color="success"
      :detail="$t('msg.common.success.detail',['Selected item','deleted'])"
      @select-ok="searchItem"
    ></dialogWindow>
    <!-- 203665 Remove unuse code
    <dialogWindow
      ref="mergeCompareInfoDialog"
      size="max"
      title="Merge & Compare"
      color="validation"
      detail="Please select 2 to 4 items"
    ></dialogWindow>
    <dialogWindow
      ref="warningDialog"
      size="max"
      title="Merge & Compare"
      color="validation"
      detail="Should be selected rows with the same message type"
    ></dialogWindow>
    <dialogWindow
      ref="ExecuteMatchingCondition"
      size="max"
      title="Execute Matching"
      detail= 'Should be selected only "Layout Created" status for matching'
      @select-ok="searchItem"
    ></dialogWindow>
    <dialogWindow
      ref="AddSrmCondition"
      size="max"
      title="validation"
      detail= '"Uploaded" status is not possible for "Add SRM List"'
      @select-ok="searchItem"
    ></dialogWindow>
    <dialogWindow
      ref="ExecuteMatchingNoItemCondition"
      size="max"
      title="Execute Matching"
      color="validation"
      detail="There is no selected item"
    ></dialogWindow>
    <dialogWindow
      ref="MergeLayoutCondition"
      size="max"
      title="Merge & Compare"
      color="validation"
      detail="There is no selected item"
    ></dialogWindow>
    -->
    <dialogWindow
      ref="addSRMSuccesssDialog"
      size="max"
      title="Add SRM Success"
      color="success"
      :detail="$t('msg.common.success.detail',['Selected item','added'])"
      @select-ok="searchItem"
    ></dialogWindow>
    <dialogWindow
      ref="SearchCondition"
      size="max"
      title="Search"
      color="validation"
      :detail="$t('msg.common.fromDateValidate')"
    ></dialogWindow>
    <dialogWindow
      ref="RollBackCondition"
      size="max"
      title="validation"
      detail= '"Uploaded" status is not possible for "Status Rollback"'
      @select-ok="searchItem"
    ></dialogWindow>
    <dialogWindow
      ref="statusRollBackSuccesssDialog"
      size="max"
      title="Status Rollback Success"
      color="success"
      :detail="$t('msg.common.success.detail',['Selected item','rollback'])"
      @select-ok="searchItem"
    ></dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail='$t("msg.common.validateDate")'
      color="validation"
    ></dialogWindow>
  </div>
  <!-- End div-->
  <!-- End template-->
</template>

<script>
/* globals Store */
import { mapState } from "vuex";
/* Remove unuse code
  import ghIcon from '@/vue-dlb/assets/github.svg?raw'
  import browserIcon from '@/vue-dlb/assets/browser.svg?raw'
  import dialogIcon from '@/vue-dlb/assets/dialog.svg?raw'
  import downloadIcon from '@/vue-dlb/assets/download.svg?raw'
  import mergeCompareDialog from '@/vue-dlb/views/matching/MergeCompareDialog.vue'
  import controlData from '../Data/asset-creation/data_control.json'
*/

import matchedMapListDialog from '@/vue-dlb/views/matching/MatchedMapList.vue'
import repositoryMatchingDialog from '@/vue-dlb/views/matching/RepositoryMatching.vue'
import ediUploadDialog from '@/vue-dlb/views/commons/EdiFileUpload.vue'
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'
// 203728 SPKA-49 issue 5 apply date conndition
import { beforeOneMonth } from '@/vue-dlb/utils/util'
import { getAppliedTimeZone } from '@/vue-dlb/utils/util';
import { deleteDateFormatStr } from '@/vue-dlb/utils/util';
import { dateValidation } from '@/vue-dlb/utils/util';
import { resizeTableHeight } from '@/vue-dlb/common/common';
import $ from "jquery";
import config from '@/vue-caas/config/config.js';
// 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
import SystemProgress from "@/vue-dlb/components/SystemProgress.vue";
export default {
  components: {
    matchedMapListDialog,
    repositoryMatchingDialog,
    ediUploadDialog,
    dialogWindow,
    SystemProgress
  },

  data(){
    return{
    tableHeight: 0,
    isCreated: false,
    dateTimeFormat: '',
    fromdate_menu: false,
    maximumItem: 4,
    todate_menu: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: -1,
    search: '',
    dialog: false,
    tooltipWidth:300,
    successColor:'',
    errorColor:'',
    // repository_matching_table_headers: [
    //   {"value" : "checkbox", "text" : "", "width": "60", sortable: false},
    //   {"value" : "MST_MSG_SNDR", "text" : "Sender"},
    //   {"value" : "MST_MSG_RCVR", "text" : "Receiver"},
    //   {"value" : "MST_MSG_ID", "text" : "Message", "width": "100"},
    //   {"value" : "MST_MSG_VER", "text" : "Version", "width": "100"},
    //   {"value" : "MST_PRCS_STS", "text" : "Status"},
    //   {"value" : "layout", "text" : "Layout", "width": "60"},
    //   {"value" : "MAP_NAME", "text" : "Mapper", "width": ""},
    //   {"value" : "FFL_FILE_NAME", "text" : "FlatFile Layout", "width": ""},
    //   {"value" : "MPD_FILE_NAME", "text" : "Mapping Definition", "min-width": "180"},
    //   {"value" : "LAY_UPLD_DT", "text" : "Upload Date", "width": "180"},
    //   {"value" : "MST_UPD_DT", "text" : "Update Date", "width": "140"}
    // ],
     columns: [
      {field: 'custome', width: 47, checkShow : true, isShowSelect: (item) => { return item.MST_PRCS_STS !== 'MAON' }, titleAlign: 'center',columnAlign:'center',type: 'selection', isFrozen: true},
      {field: 'MST_MSG_SNDR', width: 150, columnAlign: 'left', customSlot: true, className: 'frozen-col-bg', isFrozen: true},
      {field: 'MST_MSG_RCVR', width: 120, columnAlign: 'left', customSlot: true, className: 'frozen-col-bg', isFrozen: true},
      {field: 'MST_MSG_ID', width: 120, columnAlign: 'left', customSlot: true, className: 'frozen-col-bg', isFrozen: true},
      {field: 'MST_MSG_VER', width: 100, customSlot: true, columnAlign: 'left', className: 'frozen-col-bg', isFrozen: true},
      {field: 'MST_PRCS_STS', width: 180, columnAlign: 'left', customSlot: true},
      {field: 'layout', width: 80, columnAlign: 'center'},
      {field: 'MAP_NAME', width: 300, columnAlign: 'left'},
      {field: 'FFL_FILE_NAME', width: 300, columnAlign: 'left'},
      {field: 'MPD_FILE_NAME', width: 300, columnAlign: 'left'},
      {field: 'LAY_UPLD_DT', width: 180, columnAlign: 'center', customSlot: true, isResize: true},
      {field: 'MST_UPD_DT', width: 140, columnAlign: 'center', customSlot: true, isResize: true}
    ], 
    titleRows: [[
      {fields: ['custome'], title: '', titleAlign: 'center'},
      {fields: ['MST_MSG_SNDR'], title: "Sender", titleAlign: 'center'},
      {fields: ['MST_MSG_RCVR'], title: "Receiver", titleAlign: 'center'},
      {fields: ['MST_MSG_ID'], title: "Message", titleAlign: 'center'},
      {fields: ['MST_MSG_VER'], title: "Version", titleAlign: 'center'},
      {fields: ['MST_PRCS_STS'], title: "Status", titleAlign: 'center'},
      {fields: ['layout'], title: "Layout", titleAlign: 'center'},
      {fields: ['MAP_NAME'], title: "Mapper", titleAlign: 'center'},
      {fields: ['FFL_FILE_NAME'], title: "FlatFile Layout", titleAlign: 'center'},
      {fields: ['MPD_FILE_NAME'], title: "Mapping Definition", titleAlign: 'center'},
      {fields: ['LAY_UPLD_DT'], title: "Upload Date", titleAlign: 'center'},
      {fields: ['MST_UPD_DT'], title: "Update Date", titleAlign: 'center', orderBy: "desc"}
    ]],
    repository_matching_table_data : [],
    status_arr: [
      {"value" : "", "text" : this.$t('lbl.common.conditionSearch.all')},
      {"value" : "UPLD", "text" : "Uploaded"},
      {"value" : "LAYO", "text" : "Layout Created"},
      {"value" : "MAON", "text" : "Matching Processing"},
      {"value" : "MAEN", "text" : "Matching Completed"}
    ],
    dateTypes: [
      {value: '', text: 'Search by'},
      {value: 'UPDT', text: 'Upload Date'},
      {value: 'CHDT', text: 'Update Date'},
    ],
    searchBy: 'all',
    searchByItems: [
      { text: this.$t('lbl.common.searchTypePlaceHolder'), value: 'all' },
      { text: 'Sender', value: 'MST_MSG_SNDR', },
      { text: 'Receiver', value: 'MST_MSG_RCVR' },
      { text: 'Message', value: 'MST_MSG_ID' },
      { text: 'Version', value: 'MST_MSG_VER' },
      { text: 'Map', value: 'MAP_NAME' },
      { text: 'FlatFile Layout', value: 'FFL_FILE_NAME' },
      { text: 'Mapping Definition', value: 'MPD_FILE_NAME' },
    ],
    arrLayoutDialog: [],
    dialogs: [],
    dialogId: 1,
    selected: null,
    dialogWidth: 400,
    select_layout_rows : [],
    srm_rows: [],
    layoutViewArr: [],
    params: '',
    openLayoutViewItems: {
      header: ['CUST_ID','STR_SNDR','STR_RCVR','MSG_STD','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT','PRCS_STS','LAY_PRCS_NO','ALIAS'],
      data: [{
        CUST_ID: '',
        STR_SNDR: '',
        STR_RCVR: '',
        MSG_STD: '',
        MSG_ID: '',
        MSG_VER: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: '',
        PRCS_STS: '',
        LAY_PRCS_NO: '',
        ALIAS: ''
      }]
    },
    openLayoutMatchedMapItem: {
      header: ['CUST_ID','STR_SNDR','STR_RCVR','MSG_STD','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT','PRCS_STS','LAY_PRCS_NO','ALIAS'],
      data: [{
        CUST_ID: '',
        STR_SNDR: '',
        STR_RCVR: '',
        MSG_STD: '',
        MSG_ID: '',
        MSG_VER: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: '',
        PRCS_STS: '',
        LAY_PRCS_NO: '',
        ALIAS: ''
      }]
    },
    openMergeViewItems: {
      header: ['CUST_ID','STR_SNDR','STR_RCVR','MSG_STD','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT','MSG_CNT','PRCS_STS','LAY_PRCS_NO','ALIAS'],
      data: [],
    },
    mainSearchItems: {
      header: ['CUST_ID','MSG_SNDR','MSG_RCVR','MSG_ID','DAT_TYPE','FR_DAT','TO_DAT', 'PRCS_STS'],
      data: [{
        CUST_ID: '',
        MSG_SNDR: '',
        MSG_RCVR: '',
        MSG_ID: '',
        DAT_TYPE: 'UPDT',
        FR_DAT: '',
        TO_DAT: '',
        PRCS_STS: ''
      }],
      init: {
        FR_DAT: beforeOneMonth(),
        TO_DAT: getAppliedTimeZone(),
        //DAT_TYPE: ''
        DAT_TYPE: 'UPDT'
      }
    },
    addSrmParams: {
      header: ['CUST_ID','OWNR_CUST_ID','MSG_SNDR','MSG_RCVR','MSG_ID','MSG_VER','LAY_PRCS_NO','MAP_PRCS_NO'],
      data: [],
    },
    statusRollbackParams: {
      header: ['PRCS_STS','LAY_PRCS_NO'],
      data: [],
    },
    deleteDataParams: {
      header: ['CUST_ID','MSG_SNDR','MSG_RCVR','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT','PRCS_STS','LAY_PRCS_NO'],
      data: [],
    },
    executeParams: {
      header: ['MSG_STD', 'MSG_ID', 'MSG_VER', 'LAY_PRCS_NO'],
      data: []
    },
    // enableSort: false,
    searchUploadTime: {
      header: ['CUST_ID'],
      data: [
        { CUST_ID: ''},
      ],
    },
    // Fix
    uploadingStatusNm: '',
    uploadingStatusStartDt: '',
    uploadingStatusEndDt: '',
    matchingStatusNm: '',
    matchingStatusStartDt: '',
    matchingStatusEndDt: '',
    isClickLayout: true,
    isLoading: true,
    arrFilter: [],
    // 2021.9.9 203728 SPKA-199 Change background when hover,click row in v-table
    rowCurrentClick: -1,
    listFrozen: ['MST_MSG_SNDR', 'MST_MSG_RCVR', 'MST_MSG_ID', 'MST_MSG_VER'],
    dataSort: {},
    rowKey: '',
  }},

  computed: {
    ...mapState("matching", {
      mainGrid: "mainGrid",
      dataSet01Source: "dataSet01Source",
      mapList: "mapList",
    }),
    ...mapState('dashboard', {
      uploadingStatus: 'uploadingStatus',
      matchingStatus: 'matchingStatus',
     }),
    // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
    ...mapState("common", {
      sysloadingTitle: "sysloadingTitle"
    }),
    // formTitle () {
    //   return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    // },
    disableCheckAll(){
      for (let i =0; i < this.mainGrid.length ; i++) {
        for (let j =0; j < this.mainGrid[i].data.length; j++) {
          let item = this.mainGrid[i].data[j];
          if(item.MST_PRCS_STS != "MAON"){
            return false;
          }
        }
      }
      return true;
    },
    getCommunicationList() {
      let filterBy = this.$store.getters.filter;
      let listData = this.$store.getters.communicationList;
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          return listData;
        }
        return listData.filter(item =>  {
          return item[filter] == str;
        });
      }
      return listData;
    },
    // 203728 SPKA-49 issue 5 apply date conndition
    getMaxDate () {
      if (dateValidation(deleteDateFormatStr(this.mainSearchItems.init.FR_DAT), deleteDateFormatStr(this.mainSearchItems.init.TO_DAT))) {
        return getAppliedTimeZone();
      }
      else {
        this.$refs.SearchCondition.dialog = true;
        return getAppliedTimeZone();
      }
    },
    getMinDate () {
      if (dateValidation(deleteDateFormatStr(this.mainSearchItems.init.FR_DAT), deleteDateFormatStr(this.mainSearchItems.init.TO_DAT))) {
        return this.mainSearchItems.init.FR_DAT;
      }
      else {
        this.$refs.SearchCondition.dialog = true;
        return this.mainSearchItems.init.FR_DAT;
      }
    },
    isEnableMergeView(){
    let mergeItem = this.select_layout_rows[0];
    if(this.select_layout_rows.length >=2 && this.select_layout_rows.length <=4){
      for(let i=0;i < this.select_layout_rows.length ; i++){
        if(mergeItem.MST_MSG_ID != this.select_layout_rows[i].MST_MSG_ID){
          return false
        }
      }
      return true;
    }
    return false;
    },
    isEnableExtMatching(){
      if(this.select_layout_rows.length > 0){
        for(let i=0 ; i< this.select_layout_rows.length; i++){
          if(this.select_layout_rows[i].MST_PRCS_STS != 'LAYO'){
            return true;
          }
        }
        return false;
      }
      return true;
    },
    isEnableMoveToSrm(){
      if(this.srm_rows.length > 0){
        for(let i=0 ; i< this.srm_rows.length; i++){
          if(this.srm_rows[i].MST_PRCS_STS != 'LAYO' && this.srm_rows[i].MST_PRCS_STS != 'MAEN'){
            return true;
          }
        }
        return false;
      }
      return true;
    },
    isEnableRollbackStt(){
      if(this.srm_rows.length > 0){
        for(let i=0 ; i< this.srm_rows.length; i++){
          if(this.srm_rows[i].MST_PRCS_STS != 'LAYO' && this.srm_rows[i].MST_PRCS_STS != 'MAEN'){
            return true;
          }
        }
        return false;
      }
      return true;
    },
    isEnableDelete(){
      if(this.srm_rows.length > 0){
        return false;
      }
      return true;
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    },
    '$vuetify.theme.dark'(newValue){
      this.getColor();
    },
  },

  methods: {
    displaySearchConditions(action) {
      if(action === 'expand') {
        $(".date-query-section").css("display", "block");
        $(".data-query-section").css("display", "block");
        $(".expand-search-conditions").css("display", "none");
        $(".collapse-search-conditions").css("display", "block");
      } else {
        $(".date-query-section").css("display", "none");
        $(".data-query-section").css("display", "none");
        $(".expand-search-conditions").css("display", "block");
        $(".collapse-search-conditions").css("display", "none");
      }
    },
    sortChange(data) {
      let keys = Object.keys(data);
      for (let i = 0; i < keys.length; i++) {
        let col = keys[i];
        let sort = data[col];
        Store.commit('matching/sortMapList', {col, sort});
        if(this.searchBy) {
          this.repository_matching_table_data = this.mapList;
        } else {
          this.repository_matching_table_data = this.dataSet01Source;
        }
        this.setVisibilitySortIcon(col, sort);
        this.$refs.customer_list_table.clearCurrentRow();
        this.columns.map(e => {
          $('#' + e.field + this.rowCurrentClick).removeClass('custom-row-click-v-table');
        })
        let index = this.repository_matching_table_data.findIndex(e => e.ROWID === this.rowKey);
        if(index > -1) {
          this.rowCurrentClick = index;
          this.columns.map(e => {
            $('#' + e.field + index).addClass('custom-row-click-v-table');
          })
        } else {
          this.columns.map(e => {
            $('#' + e.field + index).removeClass('custom-row-click-v-table');
          })
        }
      }
    },
    setVisibilitySortIcon(colName, sort) {
      let classVisible = `.repo-list-table .v-table-header .${colName} .v-table-sort-icon`;
      $(classVisible).css('visibility', 'visible');
      if (sort === 'reset') {
        $(classVisible).removeAttr('style');
      }
    },
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if(!dateString.match(regEx)) return false;  // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0,10) === dateString;
    },
    formatDate(side, evt) {
      let dateString = (side === 'from') ? this.masterSearchItems.init.FR_DAT: this.masterSearchItems.init.TO_DAT
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else if ((charCode !== 46 && charCode !== 8 && charCode !== 45 &&  dateString.length === 4 && !dateString.includes("-")) || 
      (charCode !== 46 && charCode !== 8 && charCode !== 45 &&  dateString.length === 7 && dateString[4] === '-' && ((dateString.match(/-/g) || []).length == 1))) {
        dateString += '-';
        (side === 'from') ? (this.masterSearchItems.init.FR_DAT = dateString) : (this.masterSearchItems.init.TO_DAT = dateString)
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === 'from') {
        if(!this.validateDateInput(this.masterSearchItems.init.FR_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.FR_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.TO_DAT = this.masterSearchItems.init.FR_DAT
        }
      }
      if (side === 'to') {
        if(!this.validateDateInput(this.masterSearchItems.init.TO_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.TO_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.TO_DAT
        }
      }
    },
    // 2021.9.89 203728 SPKA-199 Change background when hover,click row in v-table
    rowClick(rowIndex, rowData){
      this.columns.map(e => {
        $('#' + e.field + this.rowCurrentClick).removeClass('custom-row-click-v-table');
        $('#' + e.field + rowIndex).addClass('custom-row-click-v-table');
      })
      this.listFrozen.map(e => {
        $('#' + e + this.rowCurrentClick).removeClass('custom-row-click-v-table');
        $('#' + e + rowIndex).addClass('custom-row-click-v-table');
      })
      this.rowCurrentClick = rowIndex;
      this.rowKey = rowData.ROWID;
    },
    rowEnter(rowIndex){
      this.listFrozen.map(e => {
        $('#' + e + rowIndex).addClass('custom-row-click-v-table');
      })
    },
    rowLeave(rowIndex){
      if(this.rowCurrentClick !== rowIndex){
        this.listFrozen.map(e => {
          $('#' + e + rowIndex).removeClass('custom-row-click-v-table');
        })
      }
    },
    setRowClassName(index, item) {
      if(item['hidden']) {
        return 'd-none';
      }
    },
    // 203728 SPKA-49 issue 5 apply date conndition
    changeDtTp(){
      if(this.mainSearchItems.data[0].DAT_TYPE == undefined 
        || this.mainSearchItems.data[0].DAT_TYPE == null
        || this.mainSearchItems.data[0].DAT_TYPE == ''){
        this.mainSearchItems.init.FR_DAT = ''
        this.mainSearchItems.init.TO_DAT = ''
      }else{
        this.mainSearchItems.init.FR_DAT = this.mainSearchItems.init.FR_DAT||beforeOneMonth()
        this.mainSearchItems.init.TO_DAT = this.mainSearchItems.init.TO_DAT||getAppliedTimeZone()
      }
    },
    initialize() {
      this.searchItem();
    },

    onFilterFromMainGrid(str) {
      // 2021.9.10 203728 SPKA-199 Clear select row
      this.$refs.customer_list_table.clearCurrentRow();
      this.rowCurrentClick = -1;
      if(this.search == ""){
        this.searchItem();
      }
       else{
      Store.commit('matching/SET_STORE_MATCHING_FILTER', {filter : this.searchBy, str : this.search});
      let data = [];
      this.repository_matching_table_data = this.mainGrid;
      this.select_layout_rows =[];
      for(let i=0;i< this.repository_matching_table_data.length;i++){
        for(let j=0;j< this.repository_matching_table_data[i].data.length; j++){
          var minUploadDate = new Date (this.repository_matching_table_data[i].data[j].LAY_UPLD_DT.split('~',2)[0]);
          var maxUploadDate = new Date (this.repository_matching_table_data[i].data[j].LAY_UPLD_DT.split('~',2)[1]);
          var minDate = minUploadDate.getDate();
          var minMonth = minUploadDate.getMonth();
          if (minDate < 10) minDate = '0' + minDate;
          if (minMonth < 10) minMonth = '0' + minMonth;
          var maxDate = maxUploadDate.getDate();
          var maxMonth = maxUploadDate.getMonth();
          if (maxDate < 10) maxDate = '0' + maxDate;
          if (maxMonth < 10) maxMonth = '0' + maxMonth;
          this.repository_matching_table_data[i].data[j].LAY_UPLD_DT = minUploadDate.getFullYear()+'-'+minMonth+'-'+minDate
          + '~'+ maxUploadDate.getFullYear()+'-'+maxMonth+'-'+maxDate;
          data.push(this.repository_matching_table_data[i].data[j]);
          }
        }
        this.repository_matching_table_data = data;
      }

      this.createArrMerge(this.repository_matching_table_data);
    },

    getRowspan(mergeData) {
      let mergeCnt = 0;
      mergeCnt = mergeData.data.length;
      return mergeCnt;
    },
    ediUploadInfo() {
      this.searchUploadTime.data[0].CUST_ID = this.$cookies.get('comp-id');
      this.$store.dispatch('dashboard/queryUploadingStatus', this.searchUploadTime).then(() => {
        if (this.uploadingStatus) {
          this.uploadingStatusNm = this.uploadingStatus[0].STS_CD_NM;
          this.uploadingStatusStartDt = this.uploadingStatus[0].START_DT || '';
          this.uploadingStatusEndDt = this.uploadingStatus[0].END_DT || '';
        }
      });
      this.$store.dispatch('dashboard/queryMatchingStatus', this.searchUploadTime).then(() => {
        if (this.matchingStatus) {
          this.matchingStatusNm = this.matchingStatus[0].LAY_PRCS_STS_NM;
          this.matchingStatusStartDt = this.matchingStatus[0].START_DT || '';
          this.matchingStatusEndDt = this.matchingStatus[0].END_DT || '';
        }
      });
    },
    searchItem () {
      // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
      this.isLoading = true;
      this.ediUploadInfo();
      // 203728 SPKA-49 issue 5 apply date conndition
      if (dateValidation(deleteDateFormatStr(this.mainSearchItems.init.FR_DAT), deleteDateFormatStr(this.mainSearchItems.init.TO_DAT))) {
        this.mainSearchItems.data[0].FR_DAT = deleteDateFormatStr(this.mainSearchItems.init.FR_DAT);
        this.mainSearchItems.data[0].TO_DAT = deleteDateFormatStr(this.mainSearchItems.init.TO_DAT);
        this.mainSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
        Store.dispatch("matching/queryList", this.mainSearchItems).then(() => {
        console.log("--------- Finished to process ----------");
        this.repository_matching_table_data = this.dataSet01Source;
        this.select_layout_rows =[];
        this.srm_rows = [];
        for(let i=0;i< this.repository_matching_table_data.length;i++){
          // for(let j=0;j< this.repository_matching_table_data[i].data.length; j++){
            this.repository_matching_table_data[i].MST_UPD_DT= this.repository_matching_table_data[i].MST_UPD_DT.split('~',1)[0];
            var minUploadDate = new Date (this.repository_matching_table_data[i].LAY_UPLD_DT.split('~',2)[0]);
            var maxUploadDate = new Date (this.repository_matching_table_data[i].LAY_UPLD_DT.split('~',2)[1]);
            var minDate = minUploadDate.getDate();
            var minMonth = minUploadDate.getMonth()+1;
            if (minDate < 10) minDate = '0' + minDate;
            if (minMonth < 10) minMonth = '0' + minMonth;
            var maxDate = maxUploadDate.getDate();
            var maxMonth = maxUploadDate.getMonth()+1;
            if (maxDate < 10) maxDate = '0' + maxDate;
            if (maxMonth < 10) maxMonth = '0' + maxMonth;
            this.repository_matching_table_data[i].LAY_UPLD_DT = minUploadDate.getFullYear()+'-'+minMonth+'-'+minDate
            + '~'+ maxUploadDate.getFullYear()+'-'+maxMonth+'-'+maxDate;
          // }
        }

        this.createArrMerge(this.repository_matching_table_data);
        this.isLoading = false;
        // this.enableSort = true;
        }).catch(() => {
          this.isLoading = false;
        });
      } else {
        this.$refs.SearchCondition.dialog = true;
        this.isLoading = false;
      }
    },
    createArrMerge(data){
      let arrFilter = [];
      for (let i = 0; i < data.length; i++) {
        let rowitem = data[i];
        if (rowitem.LAY_PRCS_NO == null) {
          continue;
        }
        let filters = arrFilter.filter((item) => {
          return item.LAY_PRCS_NO == rowitem.LAY_PRCS_NO;
        });
        // console.log("filters : ", filters);
        if (filters.length == 1) {
          let item = filters[0];
          item.count = item.count + 1;
        } else {
          let obj = Object.assign({}, rowitem);
          arrFilter.push({
            index : i,
            LAY_PRCS_NO : obj.LAY_PRCS_NO,
            count : 1
          })
        }
      }
      this.arrFilter = arrFilter;
    },
    afterUpdateTable() {
      setTimeout(() => {
        let scrollbar = $('.v-scrollbar-wrap').first();
        let scrolltop = scrollbar.scrollTop();
        scrollbar.scrollTop(scrolltop - 1);
        scrollbar.scrollTop(scrolltop + 1);
        scrollbar.scrollTop(scrolltop);
      }, 3);
    },
    cellMerge(rowIndex,rowData,field){
      // 2021.12.7 203728 fix View for not merge
      if (field == 'custome' || field == 'layout' || field == 'MAP_NAME' || field == 'FFL_FILE_NAME' || field == 'MPD_FILE_NAME') {
        let filters = this.arrFilter.filter((item) => {
          return item.index == rowIndex;
        });
        if (filters.length == 1) {
          let filter = filters[0];
          return {
              colSpan: 1,
              rowSpan: filter.count,
              content: '',
              componentName: ''
          }
        } else {
          return {
              colSpan: 1,
              rowSpan: 1,
              content: '',
              componentName: ''
          }
        }
      }
    },
    openRepositoryMatchingDialog () {
      //Validation for Layout creaged only
      for(var i = 0; i <this.select_layout_rows.length; i++){
        this.executeParams.data[i] = {
        MSG_STD: `${this.select_layout_rows[i].MST_MSG_STD}`,
        MSG_ID: `${this.select_layout_rows[i].MST_MSG_ID}`,
        MSG_VER: `${this.select_layout_rows[i].MST_MSG_VER}`,
        LAY_PRCS_NO: `${this.select_layout_rows[i].LAY_PRCS_NO}`
        };

        this.params = this.executeParams;
        Store.commit('matching/SET_LAYOUT_POPUP_PARAM', Object.assign({}, this.params));
        let type = "repositoryMatching";
        let item = {
          id : 0
        }
        let indexArrDialog = this.findDialog("repositoryMatching_0");
        if (indexArrDialog != null) {
          return;
        }
        this.newDialog(item, type) - 1;
      }
      this.select_layout_rows =[];
    },
    itemTableChange(listCheck, item) {
      let checked = listCheck.findIndex(e=> e.ROWID === item.ROWID) > -1;
      if(item.LAY_PRCS_NO === null){
        this.selectItemChange(checked, item);
      }else{
        let data = this.repository_matching_table_data.filter(e => e.LAY_PRCS_NO === item.LAY_PRCS_NO);
        this.selectItemChangeMerged(checked, item, data);
      }
    },
    selectItemChange(checked, item) {
      let maxItem = this.maximumItem;
      if (checked == true) {
        this.select_layout_rows.push(item);
        this.srm_rows.push(item);
      } else if (checked == false) {
        let index = this.findMergeIndexItem(item, this.select_layout_rows,'ROWID');
        if (index != null) {
          this.select_layout_rows.splice(index, 1);
        }
        let srmIndex = this.findMergeIndexItem(item, this.srm_rows,'ROWID');
        if (index != null) {
          this.srm_rows.splice(index, 1);
        }
      }
    },
    selectItemChangeMerged(checked, item, list) {
      let maxItem = this.maximumItem;
      if (checked == true) {
        this.select_layout_rows.push(item);
        this.srm_rows = list;
      } else if (checked == false) {
        let index = this.findMergeIndexItem(item, this.select_layout_rows,'ROWID');
        if (index != null) {
          this.select_layout_rows.splice(index, 1);
        }
        for(let i = 0 ; i < list.length ; i++){
         let srmIndex = this.findMergeIndexItem(list[i], this.srm_rows,'ROWID');
          if (srmIndex != null) {
            this.srm_rows.splice(srmIndex, 1);
          }
        }
      }
    },

    openEdiFileUploadDialog (){
      let type = "ediUploadFile";
      let item = {
        id : 0
      }
      let indexArrDialog = this.findDialog("ediUploadFile_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },

    openMatchedMapListDialog (item) {
      this.openLayoutMatchedMapItem.data[0].CUST_ID  = $cookies.get('comp-id');
      this.openLayoutMatchedMapItem.data[0].STR_SNDR = item.MST_MSG_SNDR;
      this.openLayoutMatchedMapItem.data[0].STR_RCVR = item.MST_MSG_RCVR;
      this.openLayoutMatchedMapItem.data[0].MSG_STD  = item.MST_MSG_STD;
      this.openLayoutMatchedMapItem.data[0].MSG_ID  = item.MST_MSG_ID;
      this.openLayoutMatchedMapItem.data[0].MSG_VER  = item.MST_MSG_VER;
      this.openLayoutMatchedMapItem.data[0].DAT_TYPE  = this.mainSearchItems.data[0].DAT_TYPE;
      this.openLayoutMatchedMapItem.data[0].FR_DAT = this.mainSearchItems.data[0].FR_DAT;
      this.openLayoutMatchedMapItem.data[0].TO_DAT = this.mainSearchItems.data[0].TO_DAT;
      this.openLayoutMatchedMapItem.data[0].PRCS_STS = item.MST_PRCS_STS;
      if (item.MST_PRCS_STS === "UPLD") {
        this.openLayoutMatchedMapItem.data[0].LAY_PRCS_NO = '';
      } else {
        this.openLayoutMatchedMapItem.data[0].LAY_PRCS_NO = item.LAY_PRCS_NO
      }
      this.openLayoutMatchedMapItem.data[0].ALIAS = "ALIAS_O" + item.ROWID;

      this.params = this.openLayoutMatchedMapItem.data[0];
      Store.commit('matching/SET_MATCHED_MAP_POPUP_PARAM', Object.assign({}, this.params));

      let type = "MatchedMapList";
      let id = `${type}_${item.id}`;
      let indexArrDialog = this.findDialog(id);
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openMergeView() {
        this.openMergeViewItems.data = [];
        let mergeItem = this.select_layout_rows[0];
        let msg_cnt = 0;
        for(var i = 0; i <this.select_layout_rows.length; i++){
          msg_cnt = msg_cnt + parseInt(this.select_layout_rows[i].MSG_CNT);
          this.openMergeViewItems.data[i] = {
            CUST_ID: $cookies.get('comp-id'),
            STR_SNDR: `${this.select_layout_rows[i].MST_MSG_SNDR}`,
            STR_RCVR: `${this.select_layout_rows[i].MST_MSG_RCVR}`,
            MSG_STD: `${this.select_layout_rows[i].MST_MSG_STD}`,
            MSG_ID: `${this.select_layout_rows[i].MST_MSG_ID}`,
            MSG_VER: `${this.select_layout_rows[i].MST_MSG_VER}`,
            DAT_TYPE: `${this.mainSearchItems.data[0].DAT_TYPE}`,
            FR_DAT: `${this.mainSearchItems.data[0].FR_DAT}`,
            TO_DAT: `${this.mainSearchItems.data[0].TO_DAT}`,
            PRCS_STS: `${this.select_layout_rows[i].MST_PRCS_STS}`,
            LAY_PRCS_NO: `${this.select_layout_rows[i].LAY_PRCS_NO}`,
            ALIAS: `ALIAS_${this.select_layout_rows[i].ROWID}`
          };
        }
        this.params = this.openMergeViewItems.data;
        let querystring = 'popup=true&';
        if(this.$vuetify.theme.isDark == true){
          querystring += 'theme=Dark'
        } else {
          querystring += 'theme=Light'
        }
        var w = window.open(`/edimanager/AnalysisCompareMerge?${querystring}`, '_blank', "width=1825,height=800,left=100,top=100");
        w.params = this.params;
        // 20218.7.13 203728 SPKA-153 close new window expired.
        w.newWindowExpire = true;
        w.total_cnt = msg_cnt;
        w.mode = "MatchingMergeView"
        w.pageTitle = "Compare & Merge"
        w.theme = false;
        if(this.$vuetify.theme.isDark == true){
          w.theme = this.$vuetify.theme.isDark;
        }
        w.parent = this;// 2021.4.12 203728 SPKA-52 => bug 16
        w.closePopup = () => {
          w.close();
          w.parent.select_layout_rows = [];
          w.parent.srm_rows=[];
          w.parent.initialize();
        }

        if (typeof window.mergeOpenWindow == 'undefined') {
          window.mergeOpenWindow = {'close' : w.closePopup};
        } else {
          window.mergeOpenWindow['close'] = w.closePopup;
        }
        w.onbeforeunload = w.closePopup;
      // }
    },

    openLayoutView(item) {
      console.log("-----------------------LAYOUT--------------------");
      // let index = this.findIndexItem(item, this.layoutViewArr,'ROWID');
      // if (index != null) {
      //   window.layoutFocus[item.ROWID.toString()]();
      //   return;
      // }
      let index = this.layoutViewArr.findIndex(e => e.ROWID === item.ROWID);
      if (index > -1) return window.layoutFocus[item.ROWID]();

      this.openLayoutViewItems.data[0].CUST_ID  = $cookies.get('comp-id');
      this.openLayoutViewItems.data[0].STR_SNDR = item.MST_MSG_SNDR;
      this.openLayoutViewItems.data[0].STR_RCVR = item.MST_MSG_RCVR;
      this.openLayoutViewItems.data[0].MSG_STD  = item.MST_MSG_STD;
      this.openLayoutViewItems.data[0].MSG_ID  = item.MST_MSG_ID;
      this.openLayoutViewItems.data[0].MSG_VER  = item.MST_MSG_VER;
      this.openLayoutViewItems.data[0].DAT_TYPE  = this.mainSearchItems.data[0].DAT_TYPE;
      this.openLayoutViewItems.data[0].FR_DAT = this.mainSearchItems.data[0].FR_DAT;
      this.openLayoutViewItems.data[0].TO_DAT = this.mainSearchItems.data[0].TO_DAT;
      this.openLayoutViewItems.data[0].PRCS_STS = item.MST_PRCS_STS;
      this.openLayoutViewItems.data[0].MSG_CNT = item.MSG_CNT;
      if (item.MST_PRCS_STS === "UPLD") {
        this.openLayoutViewItems.data[0].LAY_PRCS_NO = '';
      } else {
        this.openLayoutViewItems.data[0].LAY_PRCS_NO = item.LAY_PRCS_NO
      }
      this.openLayoutViewItems.data[0].ALIAS = '';
      this.openLayoutViewItems.data[0].ROWID = item.ROWID;
      this.params = this.openLayoutViewItems.data[0];
      // 203737 05/14/2021 Issue 16 New windown popup doesn't open
      // this.layoutViewArr.push(item);
      if (!this.isClickLayout) {
        return;
      }
      this.isClickLayout = false;
      Store.commit('layout/SET_LAYOUT_WINDOW_PARAM', Object.assign({}, this.params));
      let querystring = 'popup=true&';
      if(this.$vuetify.theme.isDark == true){
        querystring += 'theme=Dark'
      } else {
        querystring += 'theme=Light'
      }

      var w = window.open(`/edimanager/EdiAnalyzedView/${item.ROWID}?${querystring}`, '_blank', "width=1550,height=800,left=100,top=30");
      w.params = this.params;
      // 20218.7.13 203728 SPKA-153 close new window expired.
      w.newWindowExpire = true;
      w.mode ="MatchingMergeView"
      if(this.$vuetify.theme.isDark == true){
        w.theme = this.$vuetify.theme.isDark;
      }
      w.parent = this;// 2021.4.12 203728 SPKA-52 => bug 16
      // w.closePopup = () => {
      //   let index = w.parent.findIndexItem(item, w.parent.layoutViewArr, 'ROWID');
      //   w.parent.layoutViewArr.splice(index, 1);
      //   Store.commit('layout/DELETE_LAYOUT_WINDOW_PARAM', Object.assign({}, w.parent.params));
      //   w.close();
      //   w.parent.initialize();
      // }
      w.addEventListener("load", () => {
        this.layoutViewArr.push(item);
        this.isClickLayout = true;
        console.log(this.layoutViewArr)
      });

      w.addEventListener("message", (data) => {
        let message = data.data.message;
        console.log(message)
        if (message) {
          let index = this.findIndexItem(item, this.layoutViewArr, 'ROWID');
          this.layoutViewArr.splice(index, 1);
          Store.commit('layout/DELETE_LAYOUT_WINDOW_PARAM', Object.assign({}, this.params));
          
          if (message === "btn-close") {
            //2021.6.1 203728 SPKA-129 search again when close popup
            this.initialize();
            w.close();
          }
        }
      }, false);
      w.focusPopup = () => {
        w.focus();
      }
      if (typeof window.layoutOpenWindow == 'undefined' || typeof window.layoutFocus == 'undefined') {
        window.layoutOpenWindow = {[item.ROWID.toString()] : w.closePopup};
        window.layoutFocus = {[item.ROWID.toString()] : w.focusPopup};
      } else {
        window.layoutOpenWindow[item.ROWID.toString()] = w.closePopup;
        window.layoutFocus[item.ROWID.toString()] = w.focusPopup;
      }
      // w.onbeforeunload = w.closePopup;
    },

    newDialog (item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    removeDialog (dialog) {
      let id = dialog.id
      let index = this.findDialog(id)
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1)
      if (this.selected && this.selected.id === id) this.selected = null
    },
    findDialog (id, dialogs) {
      if (!dialogs) dialogs = this.dialogs
      let index = dialogs.findIndex((val) => {
        return val.id === id
      })
      return (index > -1) ? index : null
    },
    generateDialog (item, type) {
      let id = `${type}_${item.id}`;
      this.arrLayoutDialog.push({id : id});
      this.dialogId++
      let name = 'Dialog ' + id
      let options = {left : 30 * this.dialogId, top : 30 * this.dialogId};
      return { id, item, name, type, options }
    },
    dialogDragEnd (obj) {
      let index = this.findDialog(obj.id)
      this.$set(this.dialogs[index].options, 'left', obj.left)
      this.$set(this.dialogs[index].options, 'top', obj.top)
    },
    selectDialog (obj) {
      let index = this.findDialog(obj.id)
      this.selected = this.dialogs[index]
    },
    selectAllChange(listCheck) {
      let maxItem = this.maximumItem;
      let data = listCheck.filter(e => e.MST_PRCS_STS !== 'MAON');
      this.select_layout_rows = listCheck;
      this.srm_rows = listCheck;
      this.$refs.customer_list_table.$forceUpdate();
    },
    findIndexItem(item, arr, col) {
      let prop = (typeof col == 'undefined') ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop]
      })
      return (index > -1) ? index : null
    },
    findMergeIndexItem(item, arr, col) {
      let prop = (typeof col == 'undefined') ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop]
      })
      return (index > -1) ? index : null
    },
    addSRMList() {
      for(var i = 0; i <this.srm_rows.length; i++){
        this.addSrmParams.data[i] = {
          CUST_ID: $cookies.get('comp-id'),
          OWNR_CUST_ID: $cookies.get('ownr-id'),
          MSG_SNDR: `${this.srm_rows[i].MST_MSG_SNDR}`,
          MSG_RCVR: `${this.srm_rows[i].MST_MSG_RCVR}`,
          MSG_ID: `${this.srm_rows[i].MST_MSG_ID}`,
          MSG_VER: `${this.srm_rows[i].MST_MSG_VER}`,
          LAY_PRCS_NO: `${this.srm_rows[i].LAY_PRCS_NO}`,
          MAP_PRCS_NO: `${this.srm_rows[i].MAP_PRCS_NO}`
        };
      }

      Store.dispatch("matching/addSRMList", this.addSrmParams).then(() => {
        console.log("--------- Finished to process ----------");
        this.$refs.addSRMSuccesssDialog.dialog=true;
      });

      this.select_layout_rows = [];
      this.srm_rows = [];
    },
    statusRollBack() {
        for(var i = 0; i <this.srm_rows.length; i++){
          this.statusRollbackParams.data[i] = {
            PRCS_STS: `${this.srm_rows[i].MST_PRCS_STS}`,
            LAY_PRCS_NO: `${this.srm_rows[i].LAY_PRCS_NO}`
          };
        }

        Store.dispatch("matching/statusRollBack", this.statusRollbackParams).then(() => {
          this.$refs.statusRollBackSuccesssDialog.dialog=true;
        });
      this.select_layout_rows = [];
      this.srm_rows = [];
    },
    deleteData() {
      this.$refs.deleteDialog.dialog = true;
    },
    onDelete() {
      if(this.srm_rows.length > 0){
        for(var i = 0; i <this.srm_rows.length; i++){
          this.deleteDataParams.data[i] = {
            CUST_ID: $cookies.get('comp-id'),
            MSG_SNDR: `${this.srm_rows[i].MST_MSG_SNDR}`,
            MSG_RCVR: `${this.srm_rows[i].MST_MSG_RCVR}`,
            MSG_ID: `${this.srm_rows[i].MST_MSG_ID}`,
            MSG_VER: `${this.srm_rows[i].MST_MSG_VER}`,
            DAT_TYPE: `${this.mainSearchItems.data[0].DAT_TYPE}`,
            FR_DAT: `${this.mainSearchItems.data[0].FR_DAT}`,
            TO_DAT: `${this.mainSearchItems.data[0].TO_DAT}`,
            PRCS_STS: `${this.srm_rows[i].MST_PRCS_STS}`,
            LAY_PRCS_NO: `${this.srm_rows[i].LAY_PRCS_NO}`
          };
        }
        Store.dispatch("matching/deleteMatchingProcData", this.deleteDataParams).then(() => {
          this.$refs.deleteSuccesssDialog.dialog=true;
        });
      }else {
        this.$refs.RollBackCondition.dialog = true;
      }
      this.select_layout_rows = [];
      this.srm_rows = [];
    },
    customSort(items, index, isDesc) {
      // if (!this.enableSort) {
      //   return items;
      // }
      let prop = index[0];
      let desc = isDesc[0];

      this.repository_matching_table_data.forEach(e => {
        e.data.sort((a, b) => {
            let valuea = (desc) ? a[prop] : b[prop];
            let valueb = (desc) ? b[prop] : a[prop];
            if (valuea > valueb) {
              return -1;
            }
            if (valuea < valueb) {
              return 1;
            }
          });
      });

      this.repository_matching_table_data.sort((a, b) => {
        let valuea = (desc) ? b.data[0][prop] : a.data[0][prop];
        let valueb = (desc) ? a.data[0][prop] : b.data[0][prop];
        if (valuea > valueb) {
          return 1;
        }
        if (valuea < valueb) {
          return -1;
        }
      });

      return this.repository_matching_table_data;
    },
    allowedDates(val){
      let date= getAppliedTimeZone();
      if(val <= date){
        return val;
      }
    },
    getColor() {
      if (this.$vuetify.theme.dark) {
        this.successColor = '#2FF1B2';
        this.errorColor = '#EB1E50';
      } else {
        this.successColor = '#61B0FF';
        this.errorColor = '#FF7B7A';
      }
    }
  },

  created() {
    this.changeDtTp();
    this.dateTimeFormat = config.dateTimeFormat;
    this.tooltipWidth=config.tooltipWidth;
    this.searchItem();
    this.isCreated = true;
    Store.commit('matching/RESET_FILTER_AND_SORT');
  },

  updated: function() {
    let self = this;
    let arrClassMinus = [];
    let arrClassPlus = [];

    if (this.isCreated) {
      self.tableHeight = resizeTableHeight(arrClassMinus, arrClassPlus, true) + 20;
      this.isCreated = false;
    }

    $(window).resize(function (event) {
      self.tableHeight = resizeTableHeight(arrClassMinus, arrClassPlus, true) + 20;
    })
  },

  mounted() {
    // let self = this;
    // $('th').each(function(index) {
    //   this.addEventListener('click',function(){
    //     self.enableSort = true;
    //   }, true);
    // });
  },

}
</script>

<style>

/* Remove unuse code
.tab-text {
  padding-left: 5px !important;
  justify-content: left !important;
}
.v-tabs.theme--dark > .v-item-group {
  background-color: #424242 !important;
}
.v-tabs.theme--dark > .v-item-group > .v-window.v-item-group {
  background-color: #424242 !important;
}

.data-analysis-table.matching-repository-table tr.layout_created_row{
  background: #eaf1f8 !important;
}
.data-analysis-table.matching-repository-table tr.layout_created_row .checkbox-col {
  padding-left: 26px;
}
.matching-repository-table tr.layout_created_row span {
  border: 1px solid #C4C4C4;
  color: black;
  padding-left: 6px;
  padding-right: 6px;
}
.dialog-700{
  width: 700px !important;
}
.customer-edi-list-action-section {
  margin-top: 12px;
}
.repository-page-title{
  color: #0082ba;
  padding-top: 30px;
  padding-bottom: 15px;
}
.data-analysis-table {
  padding-bottom: 15px !important;
}
div.page-info-text {
  padding-top: 20px;
}
div.table-pagination ul.v-pagination {
  justify-content: inherit;
}
div.table-pagination ul li:not(:first-child):not(:last-child) {
  display : none;
}
div.table-pagination ul li button {
  width : 70px;
  height : 40px;
  margin-top : 0px;
  background-color : #3B3E49 !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  color : white !important;
}
div.table-pagination ul li:first-child i::before {
  content : "\f0d9";
  font-size : 14px;
}
div.table-pagination ul li:first-child i::after {
  content : " Prev";
  font-size : 14px;
  font-family: monospace;
  white-space: pre;
}
div.table-pagination ul li:last-child i::before {
  content : "Next ";
  font-size : 14px;
  font-family: monospace;
  white-space: pre;
}
div.table-pagination ul li:last-child i::after {
  content : "\f0da";
  font-size : 14px;
}
*/
.matching-repository-table .select-checkbox-layout-table.v-input--selection-controls {
  padding-left: 0px;
}
.data-analysis-table.matching-repository-table td.message-col{
  text-align: center;
  font-weight: bold;
}
.matching-repository-table td.map-col{
  text-align: left;
  /* font-weight: bold; */
}
.matching-repository-table td.map-col a{
  text-decoration: underline;
}
.matching-repository-table td.flatfile-layout-col{
  text-align: left;
  /* font-weight: bold; */
}
.matching-repository-table td.mapping-definition-col{
  text-align: left;
  /* font-weight: bold; */
}
.matching-repository-table td.status-col{
  text-align: left;
  /* font-weight: bold; */
}
.search-button-data-analysis-table.repomatching.v-text-field.v-text-field--solo.v-input--dense .v-input__control{
  min-height: 30px !important;
}
.data-analysis-table.matching-repository-table td.layout-col{
  text-align: center;
  font-weight: normal;
  text-decoration: underline;
}
.uploaded_status_cell{
  color: #606268 !important;
}
.layout_created_status_cell{
  color: #0082BA !important;
}
.matching_processing_cell{
  color: #DDAB2C !important;
}
.matching_completed_cell{
  color: #309D27 !important;
}
.matching-repository-table .v-data-table__wrapper{
  overflow-y: auto ;
  /* min-height: 678px;
  max-height: 679px ; */
}
/*2020-01-09: remove by Nam NN fix for theme light
.theme--light.v-data-table.v-data-table--fixed-header thead th{
  background-color: #496D94;
} */
.data-analysis-table.matching-repository-table thead{
  /* background: #496D94 !important; */
  border-top: none !important;
}
.v-application a.layout-map-color{
  color: #0082BA;
}
.page-filter-section .d-inline-flex{
  margin-right:10px ;
}
@media screen and (max-width: 1280px) {
  .btn-form-control button.status-rollback-button{
    width: 160px !important;
  }
  .btn-form-control button.delete-customer-edi-list-button:last-child{
    width: 85px !important;
  }
}
.matching-repository-table thead th:first-child i.v-data-table-header__icon.mdi-arrow-up{
  display: none;
}
.v-application .matching-repository-table .text-start{
  text-align: center !important;
}
</style>